import React from "react";
import { createRoot } from "react-dom/client";
import axios from "axios";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Provider } from "react-redux";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { CookiesProvider } from "react-cookie";
import { BrowserRouter } from "react-router-dom";
import Cookies from "js-cookie";

import store from "./redux/store";
import App from "./App";

import "./index.css";

const persistor = persistStore(store);

// Axios Global Configuration
const API_URL = import.meta.env.VITE_API_URL;
const token = Cookies.get("token");
axios.defaults.withCredentials = true;
axios.defaults.baseURL = `${API_URL}`;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers["Accept-Encoding"] = "gzip, deflate, br";
if (token) {
  axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;
}

// 401 interceptor - redirect to auth page if 401 status
axios.interceptors.response.use(
  (success) => {
    return success;
  },
  (error) => {
    const res = error?.response ? error?.response?.data?.error?.errorCode : null;

    if (res === 401) {
      if (window.location.pathname !== "/auth") {
        Cookies.remove("token");
        localStorage.removeItem("userProfile");
        window.location = "/auth/login";
      }
    }
    return Promise.reject(error);
  }
);

const container = document.getElementById("root");
const root = createRoot(container);
root.render(
  <BrowserRouter>
    <CookiesProvider>
      <GoogleOAuthProvider clientId={import.meta.env.VITE_GOOGLE_CLIENT_ID}>
        <Provider store={store}>
          <PersistGate loading={<div>Loading</div>} persistor={persistor}>
            <App />
          </PersistGate>
        </Provider>
      </GoogleOAuthProvider>
    </CookiesProvider>
  </BrowserRouter>
);

// Vite PWA plugin automatically handles service worker registration
// No need for manual service worker registration
